/* eslint-disable react-hooks/exhaustive-deps */
import i18n from "../../plugins/locale/i18n";
import loadDictionary from "../../plugins/locale/load-dictionary";
import { useEffect, useMemo, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import Pasoonate from "pasoonate";
import ExcleJS from "exceljs";
import { saveAs } from "file-saver";
import BankAccountService from "../../service/bank-account-service";

const bankAccountService = new BankAccountService();

await loadDictionary("bank-account-transactions-page");

function BankAccountTransactionsPage() {
  const [count, setCount] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [transactionElements, setTransactionElements] = useState([]);
  const [bankAccount, setBankAccount] = useState(null);
  const [filterFromDay, setFilterFromDay] = useState(0);
  const [filterFromMonth, setFilterFromMonth] = useState(0);
  const [filterFromYear, setFilterFromYear] = useState(0);
  const [filterToDay, setFilterToDay] = useState(0);
  const [filterToMonth, setFilterToMonth] = useState(0);
  const [filterToYear, setFilterToYear] = useState(0);
  const exportData = useRef([]);
  const params = useParams();
  const monthOptions = useMemo(() => {
      const options = [];
      const monthList = Pasoonate.trans('jalali.month_name', 'fa');
      const currentMonth = Pasoonate.make().jalali().getMonth();
      
      for(let i in monthList) {
          options.push(<option key={i} value={i}>{monthList[i]}</option>);
      }

      setFilterFromMonth(currentMonth);
      setFilterToMonth(currentMonth);

      return options;
  }, []);
  const dayOptions = useMemo(() => {
      const options = [];
      const currentDay = Pasoonate.make().jalali().getDay();
      
      for(let i = 1; i <= 31; i++) {
          options.push(<option key={i} value={i}>{i}</option>);
      }

      setFilterFromDay(currentDay);
      setFilterToDay(currentDay);

      return options;
  }, []);
  const reloadList = (from, to) => {
    setIsLoading(true);
    const fromDate = from || new Date();
    const toDate = to || new Date();
    const bankAccountId = params.bankAccountId;

    bankAccountService.transactions(bankAccountId, fromDate, toDate).then((result) => {
      let key = 1;
      const elements = result.map((transaction) =>
        <tr key={key++} >
          <td><div dir="ltr" className="text-end">{Pasoonate.make().gregorian(transaction.date).jalali().format('yyyy/MM/dd HH:mm:ss')}</div></td>
          <td><div dir="ltr" className="text-end">{transaction.credit_amount > 0 ? Number(transaction.credit_amount).toLocaleString() : `(${Number(transaction.debit_amount).toLocaleString()})`}</div></td>
          <td>{transaction.description}</td>
          <td><div dir="ltr" className="text-end">{Number(transaction.balance).toLocaleString()}</div></td>
          <td>{transaction.transaction_identity}</td>
          <td>{transaction.transaction_trace}</td>
          <td>{transaction.branch_code}</td>
          <td>{transaction.branch_name}</td>
          <td>{transaction.source_account}</td>
          <td>{transaction.destination_account}</td>
        </tr>
      );
      
      setTransactionElements(elements);
      setCount(elements.length);
      setIsLoading(false);
      exportData.current = result;   
    }).catch((reason) => {
      console.log(reason);
      exportData.current = [];
    });
  };
  const filter = () => {
    const from = Pasoonate.make().jalali().setDateTime(filterFromYear, filterFromMonth, filterFromDay, 0, 0, 0).gregorian().getDateTime();
    const to = Pasoonate.make().jalali().setDateTime(filterToYear, filterToMonth, filterToDay, 23, 59, 59).gregorian().getDateTime();
    const fromDate = new Date(from.year, from.month - 1, from.day, from.hour, from.minute, from.second);
    const toDate = new Date(to.year, to.month - 1, to.day, to.hour, to.minute, to.second);

    reloadList(fromDate, toDate);
  };

  const downloadExcelFile = () => {
      const workbook = new ExcleJS.Workbook();
  
      workbook.creator = "Payment Service";
      workbook.created = new Date();
  
      const sheet = workbook.addWorksheet("sheet_1");
      sheet.views = [{rightToLeft: true}];
  
      const header = sheet.getRow(1);
      header.getCell(1).value = i18n.t("bank-account-transactions-page.table_columns.date");
      header.getCell(2).value = i18n.t("bank-account-transactions-page.table_columns.amount");
      header.getCell(3).value = i18n.t("bank-account-transactions-page.table_columns.description");
      header.getCell(4).value = i18n.t("bank-account-transactions-page.table_columns.balance");
      header.getCell(5).value = i18n.t("bank-account-transactions-page.table_columns.transaction_identity");
      header.getCell(6).value = i18n.t("bank-account-transactions-page.table_columns.transaction_trace");
      header.getCell(7).value = i18n.t("bank-account-transactions-page.table_columns.branch_code");
      header.getCell(8).value = i18n.t("bank-account-transactions-page.table_columns.branch_name");
      header.getCell(9).value = i18n.t("bank-account-transactions-page.table_columns.source_account");
      header.getCell(10).value = i18n.t("bank-account-transactions-page.table_columns.destination_account");
  
      exportData.current.forEach((item, index) => {
        const row = sheet.getRow(index + 2);
  
        row.getCell(1).value = Pasoonate.make().gregorian(item.date).jalali().format('yyyy/MM/dd HH:mm:ss');
        row.getCell(2).value = item.credit_amount > 0 ? item.credit_amount : (item.debit_amount * -1);
        row.getCell(3).value = item.description;
        row.getCell(4).value = item.balance;
        row.getCell(5).value = item.transaction_identity;
        row.getCell(6).value = item.transaction_trace;
        row.getCell(7).value = item.branch_code;
        row.getCell(8).value = item.branch_name;
        row.getCell(9).value = item.source_account;
        row.getCell(10).value = item.destination_account;

        row.getCell(2).numFmt = "#,###_);(#,###)";
        row.getCell(4).numFmt = "#,###_);(#,###)";
      });
  
      workbook.xlsx.writeBuffer().then((buffer) => {
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  
        saveAs(blob, "bank_account_ransactions.xlsx");
      });
    };
  
  useEffect(() => {
    const currentYear = Pasoonate.make().jalali().getYear();

    setFilterFromYear(currentYear);
    setFilterToYear(currentYear);

    bankAccountService.findOne(params.bankAccountId).then((result) => {
      setBankAccount(result);
    }).catch((reason) => {
      console.log(reason);
      
    });

    reloadList();
  }, []);

  return (
    <div className="page">
      <div className="page-header bg-body border-bottom p-3 pb-0">
        <div className="row mb-4">
          <div className="col">
            <h4 className="page-title">{i18n.t("bank-account-transactions-page.page_title", {bankAccountName: bankAccount ? bankAccount.name : ""})}</h4>
          </div>
          <div className="col-auto">
            <a className="link-secondary link-offset-1 link-underline-opacity-50" href="/bank-accounts">{i18n.t("bank-account-transactions-page.bank_accounts_page_link")}</a>
          </div>
        </div>
        <div className="row mb-1">
          <div className="table-filter col-auto">
            <div className="row g-2">
              <div className="col-auto">
                <label className="form-label">از تاریخ</label>
                <div className="input-group mb-3">
                  <select className="form-select" value={filterFromDay} onChange={(e) => {setFilterFromDay(e.target.value)}}>
                    {dayOptions}
                  </select>
                  <select className="form-select" value={filterFromMonth} onChange={(e) => {setFilterFromMonth(e.target.value)}}>
                    {monthOptions}
                  </select>
                  <input type="text" dir="ltr" className="form-control" value={filterFromYear} placeholder="سال"  onChange={(e) => {setFilterFromYear(e.target.value)}}/>
                </div>
              </div>
              <div className="col-auto">
                <label className="form-label">تا تاریخ</label>
                <div className="input-group mb-3">
                  <select className="form-select" value={filterToDay} onChange={(e) => {setFilterToDay(e.target.value)}}>
                    {dayOptions}
                  </select>
                  <select className="form-select" value={filterToMonth} onChange={(e) => {setFilterToMonth(e.target.value)}}>
                    {monthOptions}
                  </select>
                  <input type="text" dir="ltr" className="form-control" value={filterToYear} placeholder="سال" onChange={(e) => {setFilterToYear(e.target.value)}}/>
                </div>
              </div>
              <div className="col-12 col-sm-auto">
                <label className="form-label d-none d-sm-inline-block">&nbsp;</label>
                <div className="d-grid mb-3">
                  <button type="submit" className={"btn btn-primary" + (isLoading ? " disabled" : "")} onClick={filter}>اعمال</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="content-area bg-body-tertiary p-3">
        <div className="row mb-2">
          <div className="table-title col">
            <h5 className="my-1">{i18n.t("bank-account-transactions-page.table_title")} ({count})</h5>
          </div>
          <div className="table-toolbar col-auto">
            <button className={"btn btn-sm btn-light mb-2 " + (isLoading ? 'disabled' : '')} type="button" onClick={downloadExcelFile}><i className="bi bi-download"></i></button>
            <button className={"btn btn-sm btn-light mb-2 " + (isLoading ? 'disabled rotate' : '')} type="button" onClick={reloadList}><i className="bi bi-arrow-clockwise"></i></button>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th width="10rem">{i18n.t("bank-account-transactions-page.table_columns.date")}</th>
                <th>{i18n.t("bank-account-transactions-page.table_columns.amount")}</th>
                <th>{i18n.t("bank-account-transactions-page.table_columns.description")}</th>
                <th>{i18n.t("bank-account-transactions-page.table_columns.balance")}</th>
                <th>{i18n.t("bank-account-transactions-page.table_columns.transaction_identity")}</th>
                <th>{i18n.t("bank-account-transactions-page.table_columns.transaction_trace")}</th>
                <th>{i18n.t("bank-account-transactions-page.table_columns.branch_code")}</th>
                <th>{i18n.t("bank-account-transactions-page.table_columns.branch_name")}</th>
                <th>{i18n.t("bank-account-transactions-page.table_columns.source_account")}</th>
                <th>{i18n.t("bank-account-transactions-page.table_columns.destination_account")}</th>
              </tr>
            </thead>
            <tbody>{transactionElements}</tbody>
          </table>
        </div>
      </div>
    </div>
  );

}

export default BankAccountTransactionsPage;